<template>
    <el-dialog title="定位点清单" class="traffic-point-list" :visible.sync="isPointListShow" width="90%" :before-close="handleClose">
        <el-main v-loading="loading"><el-table :data="tableData" border :height="400" highlight-current-row
            :span-method="objectSpanMethod">
            <el-table-column prop="trackingSourceID" label="设备类型" show-overflow-tooltip
                min-width="80" align="center">
                <template slot-scope="scope"><span>{{scope.row.trackingSource}}</span></template>
            </el-table-column>
            <el-table-column prop="createUserNameID" label="定位人" show-overflow-tooltip
                min-width="100" align="center">
                <template slot-scope="scope"><span>{{scope.row.createUserName}}</span></template>
            </el-table-column>
            <el-table-column prop="trackingDateID" label="定位时间" show-overflow-tooltip
                min-width="160" align="center">
                <template slot-scope="scope"><span>{{scope.row.trackingDate}}</span></template>
            </el-table-column>
            <el-table-column prop="trackingLocationNamePointID" label="定位地点 经度/纬度" show-overflow-tooltip
                min-width="300" align="center">
                <template slot-scope="scope"><span>{{scope.row.trackingLocationName}}： {{scope.row.longitude}} / {{scope.row.latitude}}</span></template>
            </el-table-column>
            <el-table-column label="卸货点 经度/纬度" show-overflow-tooltip
                min-width="300" align="center">
                <template slot-scope="scope"><span>{{scope.row.transport.receiverDetailAddr}}： {{scope.row.transport.endLng}} / {{scope.row.transport.endLat}}</span></template>
            </el-table-column>
            <el-table-column label="距离卸货点距离（KM）" show-overflow-tooltip
                min-width="200" align="center">
                <template slot-scope="scope"><span>{{scope.row.transport.distance.toFixed(1)}}</span></template>
            </el-table-column>
        </el-table></el-main>
        <div slot="footer" class="dialog-footer">
            <m-page :pageData="page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
        </div>
    </el-dialog>
</template>
<script>
import { pointList } from '../../../api/trafficTrajectory';
import mPage from '@/components/awesome/page/mPanel3/mPage';
export default {
    components: { mPage },
    props: {
        isPointListShow: {
            type: Boolean,
            default: false
        },
        currentItem: {
            type: Object
        }
    },
    data() {
        return {
            tableData: [],
            page: {
                'layout': 'total, sizes, prev, pager, next',
                'pageSize': 10,
                'pageSizes': [10, 20, 30, 50]
            },
            pageTotal: 0,
            pageSearch: {
                pageNo: 1,
                pageSize: 10
            },
            index: {},
            loading: false
        };
    },
    methods: {
        getList() {
            this.tableData = [];
            const params = { dispatchNo: this.currentItem.dispatchNo, ...this.pageSearch };
            this.loading = true;
            pointList(params).then(res => {
                if (res) {
                    this.loading = false;
                    const indexObj = {};
                    res.data.list.forEach((item, index) => {
                        const trackingSource = {
                            1: '直通宝',
                            2: '微信',
                            3: '小黑卡',
                            4: 'G7'
                        };
                        item.trackingSource = trackingSource[item.trackingSource] || item.trackingSource;
                        item.trackingSourceID = `${item.id}-${item.trackingSource}`;
                        item.createUserNameID = `${item.id}-${item.createUserName}`;
                        item.trackingDateID = `${item.id}-${item.trackingDate}`;
                        item.trackingLocationNamePointID = `${item.id}-${item.trackingLocationName}： ${item.longitude} / ${item.latitude}`;
                        if (item.transports) {
                            item.transports.forEach((transport, i) => {
                                this.tableData.push({
                                    ...item,
                                    transport: transport
                                });
                            });
                        } else {
                            this.tableData.push({
                                ...item,
                                transport: {}
                            });
                        }
                    });
                    this.tableData = this.mergeTableRow(this.tableData, ['id', 'trackingSourceID', 'createUserNameID', 'trackingDateID', 'trackingLocationNamePointID']);
                    this.index = indexObj;
                    this.pageTotal = res.data.totalCount;
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        pageChange(data) {
            this.pageSearch.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            this.pageSearch.pageNo = 1;
            this.pageSearch.pageSize = data;
            this.getList();
        },
        mergeTableRow(data, merge) {
            if (!merge || merge.length === 0) {
                return data;
            }
            merge.forEach((m) => {
                const mList = {};
                data = data.map((v, index) => {
                    const rowVal = v[m];
                    if (mList[rowVal]) {
                        mList[rowVal]++;
                        data[index - (mList[rowVal] - 1)][m + '-span'].rowspan++;
                        v[m + '-span'] = {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else {
                        mList[rowVal] = 1;
                        v[m + '-span'] = {
                            rowspan: 1,
                            colspan: 1
                        };
                    }
                    return v;
                });
            });
            return data;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            const span = column['property'] + '-span';
            if (row[span]) {
                return row[span];
            }
        },
        handleClose() {
            this.$emit('pointListClose');
        }
    },
    mounted() {
        this.getList();
    }
};
</script>
<style lang="less">
.traffic-point-list {
    .dialog-footer {
        overflow: hidden;
    }
}
</style>